var Base = require('_js/base');

function model($carousel) {
  var $inner = $carousel.find('.carousel-vertical-inner');
  var $items = $carousel.find('.sponsor');
  // Get height of an item.
  var itemWidth = $items.outerWidth();
  // The amount of items visible at any given time.
  var amountOfVisibleItems = 4; // parseInt($inner.data('visible-items'), 10) ;
  // Set the max height of the carousel to be equal to the amount of items specified.
  // $carousel.css({ "max-height": amountOfVisibleItems*itemHeight + "px"});
  // We need to append extra items in order to have a proper transition when moving from the position items.length -> 0.
  for (var i = 0; i < amountOfVisibleItems; i++) {
    $inner.append($($items[i]).clone());
  }

  $inner.css({
    width: ($items.length + amountOfVisibleItems) * itemWidth + 'px'
  });

  // The pixel value we should offset the container.
  var position = 0;
  // If transition is enabled.
  var transitionEnabled = true;
  var isAnimating = false;

  $('.carousel-navigation .carousel-next').on('click', moveNext);
  $('.carousel-navigation .carousel-previous').on('click', movePrevious);

  var autoRotate = window.setInterval(rotate, 2500);

  // TODO: Add support for IE 9 and older. Use top instead of transform.
  function rotate() {
    isAnimating = true;
    position += itemWidth;
    if (!transitionEnabled) {
      transitionEnabled = true;
      $inner.css({
        transition:
          '-webkit-transform 0.5s ease-out, ' +
          '-moz-transform 0.5s ease-out, ' +
          '-ms-transform 0.5s ease-out, ' +
          'transform 0.5s ease-out'
      });
    }

    setNewPosition(position);
    // If we're at the end of the list of items.
    if (position > itemWidth * ($items.length - 1)) {
      // Make sure the animation of the new position is done, then we can move the carousel back to position 0.
      window.setTimeout(function() {
        position = 0;
        transitionEnabled = false;
        $inner.css({ transition: 'none' });
        setNewPosition(position);
      }, 505);
    }
    window.setTimeout(function() {
      isAnimating = false;
    }, 505);
  }

  function setNewPosition(position) {
    $inner.css({
      '-webkit-transform': 'translate(-' + position + 'px, 0)',
      '-moz-transform': 'translate(-' + position + 'px, 0)',
      '-ms-transform': 'translate(-' + position + 'px, 0)',
      transform: 'translate(-' + position + 'px, 0)'
    });
  }

  function movePrevious() {
    if (isAnimating) return;
    clearInterval(autoRotate);
    rotate();
  }
  function moveNext() {
    if (isAnimating) return;
    clearInterval(autoRotate);
    position -= itemWidth;
    if (!transitionEnabled) {
      transitionEnabled = true;
      $inner.css({
        transition:
          '-webkit-transform 0.5s ease-out, ' +
          '-moz-transform 0.5s ease-out, ' +
          '-ms-transform 0.5s ease-out, ' +
          'transform 0.5s ease-out'
      });
    }

    setNewPosition(position);
    // If we're at the end of the list of items.
    if (position < 0) {
      // Make sure the animation of the new position is done, then we can move the carousel back to position 0.
      window.setTimeout(function() {
        position = itemWidth * ($items.length - 1);
        transitionEnabled = false;
        $inner.css({ transition: 'none' });
        setNewPosition(position);
      }, 505);
    }
  }
}

function SponsorsBlock() {
  this.init();
}

SponsorsBlock.prototype = new Base();
SponsorsBlock.prototype.init = function() {
  var $carousel = $('.carousel-vertical');
  if ($carousel.get(0) !== undefined) {
    new model($carousel);
  }
};
module.exports = SponsorsBlock;
